import React from 'react';
import { Routes as RRDRoutes, Route, Outlet } from 'react-router-dom';
import {
  // Complementary activity links
  ComplementaryActivity,
  ComplementaryActivityDetails,
  ComplementaryActivityEvaluationView,
  ActivityEvaluationArchive,
  ActivityEvaluation,
  ActivityData,
  ViewActivity
} from '@/pages/complementary-activity';
import {
  // Quiz links
  Quiz,
  QuizData,
  QuizDataProposal,
  QuizDataOpenAnswers,
  QuizCreate
} from '@/pages/Quiz';
import {
  // Reports links
  Reports,
  ViewClassroom,
  ShowEmbed,
  LiveClassesReport,
  AccessReport,
  RegistrationReport,
  CourseProgressReport,
  EnemReport,
  AccessFunnelReport,
  LevelingTestReport,
  EssayReport,
  QuestionReports,
  LiveLessonsAccessReport,
  QuizReport,
  RecordClassesReport,
  StudentPage,
  GeneralRegistrationReport,
  Metrics1,
  MetricsProfile,
  SeducPi,
  SeducPiGeral,
  SeducPiGRE
} from '@/pages/reports';
import {
  // Participants links
  Participants,
  AdministrativeProfiles,
  ManageProfile,
  Notifications,
  NotificationExtract,
  CreateOrUpdateParticipant
} from '@/pages/Participants';
import { Dashboard, ViewEvent } from '@/pages/dashboard';
import {
  // Exams links
  Exams,
  ExamsResolution,
  ExamMetrics,
  ExamsAbout,
  ExamsQuestions,
  OfflineExam,
  PrintedExam,
  CreateExam,
  ManageExam,
  ExamMetricsList
} from '@/pages/exams';
import {
  // Mock exams links
  MockExamsAbout,
  CreateMockQuestionBook
} from '@/pages/mock-exams';
import PrivateRoute from './components/PrivateRoute';
import Terms from '@/pages/Terms';
import LoginCallback from '@/pages/LoginCallback';
import { LostPassword, SignIn } from '@/pages/Login/Login';
import Register from '@/pages/Register';
import { MyTasks, ViewTask } from '@/pages/MyTasks';
import { Feed, FeedPost } from '@/pages/feed';
import {
  // Course links
  Course,
  CourseMonitoring,
  CourseRecommended,
  CourseCertificate,
  CourseModuleAbout,
  CourseCreate,
  CourseClassroom,
  CourseManage,
  CourseAbout,
  CourseCreateActivity,
  CourseAdmin,
  CreateModule,
  CreateLesson,
  ManageModule,
  ShowCourse
} from '@/pages/course';
import {
  // LMS links
  LmsStudent,
  ViewModule,
  Lesson,
  LessonResources,
  ModuleCertificate
} from '@/pages/LmsStudent';
import { Profile } from '@/pages/profile';
import { UsersShow } from '@/pages/users';
import DashboardAdmin from '@/pages/Admin';
import {
  // Classrooms links
  Classrooms,
  ManageClassroomParticipants,
  ClassroomInvitations,
  ViewInvitations,
  ClassroomImports,
  ViewImports
} from '@/pages/Admin/Classrooms';
import { Classroom, ManageParticipants } from '@/pages/Admin/Classroom';
import { Materials, ViewMaterial } from '@/pages/Materials';
import Journey from '@/pages/Journey';
import { NotFound } from '@/pages/not-found';
import { Healthcheck } from '@/pages/healthcheck';
import { Taxonomies } from '@/pages/ProgramOfStudies/taxonomies';
import { QuestionsDatabase } from '@/pages/ProgramOfStudies/QuestionsDatabase';
import CreateQuestionBook from '@/pages/ProgramOfStudies/CreateQuestionBook';
import { UpdatePublicQuestions } from '@/pages/UpdatePublicQuestions';
import { UpdateQuestionBook } from '@/pages/QuestionBooks/UpdateQuestionBook';
import {
  // Projects links
  Projects,
  CreateProject,
  GroupProjects,
  IndividualProjects,
  PersonalizedProjects,
  ProjectsView,
  ProjectsAbout,
  ViewGroupProject,
  ViewIndividualProject
} from '@/pages/projects';
import { TaskManagement, ManageExcessTasks, ManageExcessStudentTasks } from '@/pages/TaskManagement';
import { StudyPlan, StudyBlock, ViewStudyPlan } from '@/pages/StudyPlan';
import { StudyGuide, StudyGuideBlock, StudyGuideSettings, StudyGuidePanorama } from '@/pages/study-guide';
import { HelpCenter, HelpViewVideo } from '@/pages/HelpCenter';
import { default as AdmQuestions, CreateQuestion, CommentQuestion } from '@/pages/Admin/Questions';
import { Exercises, ExercisesQuestions } from '@/pages/exercises';
import { PageLayouts } from '@/layouts/page-layouts';
import DesignSystem from '@/pages/DesignSystem';
import { StudentSignUp } from '@/pages/SignUp';
import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';
import { Auditorium, AuditoriumView, CreateAuditorium } from '@/pages/auditorium';
import Privacy from '@/pages/Privacy';
import { LiveClasses, ViewLiveClass } from '@/pages/LiveClasses';
import { Essay, CreateEssay, EssayMonitoring, EssayCorrection, EssayConsult, EssayAbout, EssaySend, EssayPrint } from '@/pages/essay';
import { LessonPlan } from '@/pages/lesson-plan';
import { WeekChallenge } from '@/pages/week-challenge';
import { CreateWeekChallenge, ViewChallenge, ViewParticipantResult } from '@/pages/Admin/WeekChallenge';
import { Duels, DuelsPlayer } from '@/pages/duels';
import LiveChallengeList from '@/pages/Admin/LiveChallenge';
import CreateLiveChallenge from '@/pages/Admin/LiveChallenge/CreateLiveChallenge';
import LiveChallengeControlPanel from '@/pages/Admin/LiveChallenge/ControlPanel';
import { JoinPage, WaitingRoom, QuestionPage, AnswerFeedback, FinalResultPage } from '@/pages/LiveChallenge';
import { LiveChallengeProvider } from '@/providers/LiveChallengeProvider';
import { BulletinBoards, BulletinBoardsCreate } from '@/pages/bulletin-boards';
import { CourseSchedule } from '@/pages/course-schedule';
import PublicRegistrationForm from '@/pages/Public/SelectionRegistration';
import PublicRegistrationSuccess from '@/pages/Public/SelectionRegistration/Success';
import PublicRegistrationClosed from '@/pages/Public/SelectionRegistration/Closed';
import SelectionProcessesList from '@/pages/Admin/SelectionProcess/List';
import SelectionProcessFormPage from '@/pages/Admin/SelectionProcess/Form';
import SelectionProcessDetail from '@/pages/Admin/SelectionProcess/Detail';
import { PATHS } from './paths';
import { PlatformUsageReport } from '@/pages/reports/PlatformUsage';
import { UptimeMonthlyReport } from '@/pages/reports/UptimeMonthly';
import { PerformanceReport } from '@/pages/reports/Performance';
import Example from '@/components/custom/example';
import { LiveTransmissionsReport } from '@/pages/reports/LiveTransmissions';
import { StudyHours } from '@/pages/reports/StudyHours';
import { InterventionReport } from '@/pages/reports/Intervention';

// Componente Wrapper para o Layout.
// Ele recebe o tipo de layout e renderiza o PageWithLayouts com o Outlet dentro.
const LayoutWrapper = ({ layoutType }) => {
  return (
    <PageLayouts layoutType={layoutType}>
      {/* O Outlet renderiza o componente da rota filha */}
      <Outlet />
    </PageLayouts>
  );
};

export const Routes = () => {
  const { abilities } = usePlatformAbilities();
  const sso = process.env.REACT_APP_SSO_API_URL;
  const ssoEtipi = process.env.REACT_APP_ETIPI_SSO_API_URL;

  const RedirectToSupport = () => {
    React.useEffect(() => {
      const platformSupportUrl = process.env.REACT_APP_SUPPORT_LINK;
      window.location.href = `${platformSupportUrl}/requests/new`;
    }, []);
    return null;
  };

  return (
    <RRDRoutes>
      <Route element={<LayoutWrapper layoutType="loginLayout" />}>
        <Route
          path={PATHS.AUTH.LOGIN}
          element={<SignIn />}
        />
        <Route
          path={PATHS.AUTH.LOGIN_WITH_LINK_ROOT}
          element={<SignIn />}
        />
        {(sso || ssoEtipi) && (
          <Route
            path={PATHS.AUTH.LOGIN_CALLBACK}
            element={<LoginCallback />}
          />
        )}
        <Route
          path={PATHS.LEGAL.HELP}
          element={<RedirectToSupport />}
        />
        <Route
          path={PATHS.LEGAL.TERMS}
          element={<Terms />}
        />
        <Route
          path={PATHS.LEGAL.PRIVACY}
          element={<Privacy />}
        />
        <Route
          path={PATHS.AUTH.REGISTER}
          element={<Register />}
        />
        <Route
          path={PATHS.AUTH.FORGOT_PASSWORD}
          element={<LostPassword />}
        />
        <Route
          path={PATHS.AUTH.STUDENT_SIGNUP_WITH_LINK_ROOT}
          element={<StudentSignUp />}
        />
        <Route
          path={PATHS.AUTH.STUDENT_SIGNUP_ROOT}
          element={<StudentSignUp />}
        />
        <Route
          path={PATHS.AUTH.STUDENT_SIGNUP_ALUNO_WITH_LINK_ROOT}
          element={<StudentSignUp />}
        />
        <Route
          path={PATHS.AUTH.STUDENT_SIGNUP_ALUNO_ROOT}
          element={<StudentSignUp />}
        />
        {/* seletivo público — sem autenticação */}
        <Route
          path={PATHS.SELETIVO.PUBLIC_FORM_ROOT}
          element={<PublicRegistrationForm />}
        />
        <Route
          path={PATHS.SELETIVO.PUBLIC_SUCCESS_ROOT}
          element={<PublicRegistrationSuccess />}
        />
        <Route
          path={PATHS.SELETIVO.PUBLIC_CLOSED_ROOT}
          element={<PublicRegistrationClosed />}
        />
      </Route>

      <Route element={<LayoutWrapper layoutType="adminLayout" />}>
        <Route
          path={PATHS.COURSE.ADMIN_MANAGE_ROOT}
          element={
            <PrivateRoute
              as={CourseManage}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateMockQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateMockQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_BY_ID_ROOT}
          element={
            <PrivateRoute
              as={ExamsQuestions}
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path={PATHS.QUESTIONS.EDIT_ROOT}
          element={<PrivateRoute as={CreateQuestion} />}
        />
        <Route
          path={PATHS.QUESTIONS.CREATE_ROOT}
          element={<PrivateRoute as={CreateQuestion} />}
        />
        <Route
          path={PATHS.LMS.CREATE_MODULE_ROOT}
          element={
            <PrivateRoute
              as={CreateModule}
              roleName="Criar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.EDIT_MODULE_ROOT}
          element={
            <PrivateRoute
              as={CreateModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.MANAGE_MODULES}
          element={
            <PrivateRoute
              as={ManageModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateExam}
              roleName="Editar provas"
              roleGroup="Provas e simulados"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateExam}
              roleName="Criar provas"
              roleGroup="Provas e simulados"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.PRINT_ROOT}
          element={
            <PrivateRoute
              as={PrintedExam}
              roleName={['Visualizar exercícios', 'Visualizar lista de provas', 'Visualizar lista de simulados', 'Visualizar banco de questões', 'Visualizar exercícios', 'Visualizar resultados']}
              roleGroup={['Questões e exercícios', 'Avaliações']}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.WORKBOOK_CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.WORKBOOK_EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateQuestionBook}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.LMS.MANAGE_MODULE_ROOT}
          element={
            <PrivateRoute
              as={ManageModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.MANAGE_MODULE_DISCIPLINE_ROOT}
          element={
            <PrivateRoute
              as={ManageModule}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.CREATE_LESSON_ROOT}
          element={
            <PrivateRoute
              as={CreateLesson}
              roleName="Criar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.EDIT_LESSON_ROOT}
          element={
            <PrivateRoute
              as={CreateLesson}
              roleName="Editar módulos, disciplinas e aulas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.COURSE.CREATE_ACTIVITY_ROOT}
          element={
            <PrivateRoute
              as={CourseCreateActivity}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path={PATHS.COURSE.EDIT_ACTIVITY_ROOT}
          element={
            <PrivateRoute
              as={CourseCreateActivity}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.EXAM.WORKBOOK_MANAGE_BY_ID_ROOT}
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.WORKBOOK_MANAGE_BY_TAX_ROOT}
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.WORKBOOK_MANAGE}
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_MANAGE_BY_QB_ROOT}
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_MANAGE_BY_TAX_ROOT}
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_MANAGE}
          element={
            <PrivateRoute
              as={ManageExam}
              roleGroup="Questões e exercícios"
              roleName="Visualizar exercícios"
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_MANAGE}
          element={
            <PrivateRoute
              as={ManageExam}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_MANAGE_BY_QB_ROOT}
          element={
            <PrivateRoute
              as={ManageExam}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_MANAGE_BY_TAX_ROOT}
          element={
            <PrivateRoute
              as={ManageExam}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_BY_ID_ROOT}
          element={
            <PrivateRoute
              as={ExamsQuestions}
              enabled={abilities?.['avaliacoes-provas']}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ProjectsView}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.PRINT_ROOT}
          element={
            <PrivateRoute
              as={EssayPrint}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.SEND_BY_STUDENT_ROOT}
          element={
            <PrivateRoute
              as={EssaySend}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.SEND_ROOT}
          element={
            <PrivateRoute
              as={EssaySend}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.WEEK_CHALLENGE.CREATE}
          element={
            <PrivateRoute
              as={CreateWeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path={PATHS.WEEK_CHALLENGE.EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateWeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path={PATHS.AUDITORIUM.CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateAuditorium}
              enabled={abilities?.auditorio}
            />
          }
        />
        <Route
          path={PATHS.AUDITORIUM.EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateAuditorium}
              enabled={abilities?.auditorio}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateEssay}
              roleName={'Criar redação'}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateEssay}
              enabled={abilities?.redacao}
            />
          }
        />
        {/** Relatórios */}
        <Route
          path={PATHS.REPORTS.SEDUC_PI}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPi}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.SEDUC_PI_GRE_QB_ROOT}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPiGRE}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.SEDUC_PI_GRE_ROOT}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPiGRE}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LIVE_CLASSES}
          element={<PrivateRoute as={LiveClassesReport} />}
        />
        <Route
          path={PATHS.REPORTS.RECORD_CLASSES}
          element={
            <PrivateRoute
              as={RecordClassesReport}
              roleName="Visualizar Relatório de acessos às aulas gravadas"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.REGISTRATION}
          element={
            <PrivateRoute
              as={RegistrationReport}
              roleName="Visualizar Relatório de Cadastro"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ACCESS}
          element={
            <PrivateRoute
              as={AccessReport}
              roleName="Visualizar Relatório de Mapeamento de Acesso"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.COURSE_PROGRESS}
          element={
            <PrivateRoute
              as={CourseProgressReport}
              roleName="Visualizar Progresso dos Cursos"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.QUESTIONS}
          element={
            <PrivateRoute
              as={QuestionReports}
              roleName="Visualizar Relatório de perguntas"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.QUIZ}
          element={
            <PrivateRoute
              as={QuizReport}
              roleName="Visualizar Relatório de respostas de avaliações"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LIVE_ACCESS}
          element={
            <PrivateRoute
              as={LiveLessonsAccessReport}
              roleName="Visualizar Relatório de acessos às aulas ao vivo"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ENEM}
          element={<PrivateRoute as={EnemReport} />}
        />
        <Route
          path={PATHS.REPORTS.ACCESS_FUNNEL}
          element={
            <PrivateRoute
              as={AccessFunnelReport}
              roleName="Visualizar Relatório de Funil de Acessos"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ADHERENCE}
          element={
            <PrivateRoute
              as={GeneralRegistrationReport}
              roleName="Visualizar Relatório de Adesão"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ESSAY}
          element={
            <PrivateRoute
              as={EssayReport}
              roleName="Visualizar Redações"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.ESSAY_STUDENT_ROOT}
          element={<PrivateRoute as={StudentPage} />}
        />
        <Route
          path={PATHS.REPORTS.SEDUC_PI_GERAL}
          element={
            <PrivateRoute
              enabled={abilities?.auditorio}
              as={SeducPiGeral}
            />
          }
        />
        <Route
          path={PATHS.REPORTS.PLATFORM_USAGE}
          element={
            <PrivateRoute
              as={PlatformUsageReport}
              roleName="Visualizar Relatório de Uso"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LEVELING_TEST}
          element={<PrivateRoute as={LevelingTestReport} />}
        />
        <Route
          path={PATHS.REPORTS.UPTIME_MONTHLY}
          element={
            <PrivateRoute
              as={UptimeMonthlyReport}
              roleName="Visualizar Relatório de Disponibilidade"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.INTERVENTION_NECESSITY}
          element={
            <PrivateRoute
              as={InterventionReport}
              roleName="Visualizar Relatório de Necessidade de Intervenção"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.LIVE_TRANSMISSION}
          element={
            <PrivateRoute
              as={LiveTransmissionsReport}
              roleName="Visualizar Relatório de Transmissão ao Vivo"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.PERFORMANCE}
          element={
            <PrivateRoute
              as={PerformanceReport}
              roleName="Visualizar Relatório Performance 360"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.REPORTS.STUDY_HOURS}
          element={
            <PrivateRoute
              as={StudyHours}
              roleName="Visualizar Relatório de Horas de Estudo"
              roleGroup="Relatórios"
            />
          }
        />
        <Route
          path={PATHS.COURSE.EDIT_ROOT}
          element={<PrivateRoute as={CourseCreate} />}
        />
        <Route
          path={PATHS.COURSE.CREATE_ROOT}
          element={<PrivateRoute as={CourseCreate} />}
        />
        {/* Banners */}
        <Route
          path={PATHS.BANNERS.EDIT_ROOT}
          element={
            <PrivateRoute
              as={BulletinBoardsCreate}
              roleName="Editar Mural"
              roleGroup="Mural"
            />
          }
        />
        <Route
          path={PATHS.BANNERS.CREATE}
          element={
            <PrivateRoute
              as={BulletinBoardsCreate}
              roleName="Criar Mural"
              roleGroup="Mural"
            />
          }
        />
        {/* desafio ao vivo - wizard sem main menu (somente create/edit) */}
        <Route
          path={PATHS.LIVE_CHALLENGE.ADMIN_CREATE_ROOT}
          element={
            <PrivateRoute
              as={CreateLiveChallenge}
              enabled={abilities?.['desafio-ao-vivo']}
            />
          }
        />
        <Route
          path={PATHS.LIVE_CHALLENGE.ADMIN_EDIT_ROOT}
          element={
            <PrivateRoute
              as={CreateLiveChallenge}
              enabled={abilities?.['desafio-ao-vivo']}
            />
          }
        />
        {/* seletivo - wizard sem main menu (somente create/edit) */}
        <Route
          path={PATHS.ADMIN_SELETIVO.NEW}
          element={<SelectionProcessFormPage />}
        />
        <Route
          path={PATHS.ADMIN_SELETIVO.EDIT_ROOT}
          element={<SelectionProcessFormPage />}
        />
        {/* desafio ao vivo - fluxo do aluno (kiosk fullscreen, sem main menu) */}
        <Route
          path={PATHS.LIVE_CHALLENGE.JOIN}
          element={
            <LiveChallengeProvider>
              <PrivateRoute
                as={JoinPage}
                enabled={abilities?.['desafio-ao-vivo']}
              />
            </LiveChallengeProvider>
          }
        />
        <Route
          path={PATHS.LIVE_CHALLENGE.WAITING_ROOT}
          element={
            <LiveChallengeProvider>
              <PrivateRoute
                as={WaitingRoom}
                enabled={abilities?.['desafio-ao-vivo']}
              />
            </LiveChallengeProvider>
          }
        />
        <Route
          path={PATHS.LIVE_CHALLENGE.QUESTION_ROOT}
          element={
            <LiveChallengeProvider>
              <PrivateRoute
                as={QuestionPage}
                enabled={abilities?.['desafio-ao-vivo']}
              />
            </LiveChallengeProvider>
          }
        />
        <Route
          path={PATHS.LIVE_CHALLENGE.RESULT_ROOT}
          element={
            <LiveChallengeProvider>
              <PrivateRoute
                as={AnswerFeedback}
                enabled={abilities?.['desafio-ao-vivo']}
              />
            </LiveChallengeProvider>
          }
        />
        <Route
          path={PATHS.LIVE_CHALLENGE.FINAL_ROOT}
          element={
            <LiveChallengeProvider>
              <PrivateRoute
                as={FinalResultPage}
                enabled={abilities?.['desafio-ao-vivo']}
              />
            </LiveChallengeProvider>
          }
        />
      </Route>
      {/** Fim das Rotas de Admin Layout */}

      <Route element={<LayoutWrapper layoutType="mainLayout" />}>
        <Route
          path={PATHS.DASHBOARD.ROOT}
          element={
            <PrivateRoute
              as={Dashboard}
              enabled={abilities?.dashboard}
            />
          }
        />
        <Route
          path={PATHS.DASHBOARD.EVENT_ROOT}
          element={<PrivateRoute as={ViewEvent} />}
        />
        <Route
          path={PATHS.TASKS.VIEW_ROOT}
          element={
            <PrivateRoute
              as={ViewTask}
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path={PATHS.TASKS.LIST}
          element={
            <PrivateRoute
              as={MyTasks}
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path={PATHS.FEED.LIST}
          element={
            <PrivateRoute
              as={Feed}
              roleName="Visualizar postagens e comentários"
              roleGroup="Fórum"
              enabled={abilities?.feed}
            />
          }
        />
        <Route
          path={PATHS.TASKS.MANAGEMENT_ROOT}
          element={
            <PrivateRoute
              as={TaskManagement}
              roleName="Visualizar Tarefas"
              roleGroup="Tarefas"
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path={PATHS.TASKS.MANAGEMENT_EXCESS_STUDENT_ROOT}
          element={
            <PrivateRoute
              as={ManageExcessStudentTasks}
              enabled={abilities?.tarefas}
            />
          }
        />
        <Route
          path={PATHS.TASKS.MANAGEMENT_EXCESS_ROOT}
          element={
            <PrivateRoute
              as={ManageExcessTasks}
              enabled={abilities?.tarefas}
            />
          }
        />
        {/* Course routes */}
        <Route
          path={PATHS.COURSE.RECOMMENDED}
          element={
            <PrivateRoute
              as={CourseRecommended}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.COURSE.CERTIFICATE}
          element={
            <PrivateRoute
              as={CourseCertificate}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.COURSE.MONITORING_ROOT}
          element={
            <PrivateRoute
              as={CourseMonitoring}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.COURSE.MODULE_ROOT}
          element={
            <PrivateRoute
              as={CourseModuleAbout}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.COURSE.LIST}
          element={
            <PrivateRoute
              as={Course}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.COURSE.ADMIN_DETAIL_ROOT}
          element={
            <PrivateRoute
              as={CourseAbout}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.COURSE.ADMIN_LIST}
          element={
            <PrivateRoute
              as={CourseAdmin}
              enabled={abilities?.cursos}
            />
          }
        />
        {/* Classrooms routes */}
        <Route
          path={PATHS.CLASSROOM.IMPORT_ROOT}
          element={
            <PrivateRoute
              as={ViewImports}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.IMPORTS}
          element={
            <PrivateRoute
              as={ClassroomImports}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.INVITE_ROOT}
          element={
            <PrivateRoute
              as={ViewInvitations}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.INVITES}
          element={
            <PrivateRoute
              as={ClassroomInvitations}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.MANAGE_ROOT}
          element={
            <PrivateRoute
              as={ManageClassroomParticipants}
              enabled={abilities?.cursos}
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.LIST_TURMAS}
          element={
            <PrivateRoute
              as={Classrooms}
              enabled={abilities?.cursos}
            />
          }
        />

        <Route
          path={PATHS.LMS.VIEW_MODULE_ROOT}
          element={
            <PrivateRoute
              as={ViewModule}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.VIEW_DISCIPLINE_ROOT}
          element={
            <PrivateRoute
              as={Lesson}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.VIEW_LESSON_ROOT}
          element={
            <PrivateRoute
              as={LessonResources}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.LMS.ROOT}
          element={
            <PrivateRoute
              as={LmsStudent}
              roleName="Visualizar lista de módulos e seus conteúdos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.COURSE.SHOW_ROOT}
          element={<PrivateRoute as={ShowCourse} />}
        />
        <Route
          path={PATHS.COURSE.SHOW_CLASSROOM_ROOT}
          element={<PrivateRoute as={CourseClassroom} />}
        />
        <Route
          path={PATHS.COURSE.SHOW_CLASSROOM_LESSON_ROOT}
          element={<PrivateRoute as={CourseClassroom} />}
        />

        <Route
          path={PATHS.STUDY_PLAN.ROOT}
          element={
            <PrivateRoute
              as={StudyPlan}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.STUDY_GUIDE.BLOCK_ROOT}
          element={
            <PrivateRoute
              as={StudyGuideBlock}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.STUDY_GUIDE.HOW_IT_WORKS}
          element={
            <PrivateRoute
              as={StudyGuidePanorama}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.STUDY_GUIDE.SETTINGS}
          element={
            <PrivateRoute
              as={StudyGuideSettings}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.STUDY_GUIDE.ROOT}
          element={
            <PrivateRoute
              as={StudyGuide}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.QUESTIONS.TAB_ROOT}
          element={
            <PrivateRoute
              as={Exercises}
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.QUESTIONS.TAB_DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ExercisesQuestions}
              enabled={abilities?.['avaliacoes-apostilas']}
            />
          }
        />
        <Route
          path={PATHS.MATERIALS.DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ViewMaterial}
              enabled={abilities?.['cursos-materiais']}
            />
          }
        />
        <Route
          path={PATHS.MATERIALS.LIST}
          element={
            <PrivateRoute
              as={Materials}
              enabled={abilities?.['cursos-materiais']}
            />
          }
        />
        <Route
          path={PATHS.METRICS.INSTITUTIONAL_CLASSROOM_ROOT}
          element={
            <PrivateRoute
              as={ViewClassroom}
              roleName="Visualizar dados e métricas"
              roleGroup={['Questionário de Percepção', 'Cursos', 'Projetos', 'Participantes e perfis administrativos', 'Questões e exercícios', 'Avaliações', 'Taxonomias', 'Arquivos e atividades complementares', 'Fórum', 'Tarefas']}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route //metabase
          path={PATHS.METRICS.TAB_REPORT_ROOT}
          element={
            <PrivateRoute
              as={ShowEmbed}
              roleName={['Visualizar dados e métricas', 'Mantenedor', 'Institucional', 'Regional']}
              roleGroup={[
                'Questionário de Percepção',
                'Cursos',
                'Projetos',
                'Participantes e perfis administrativos',
                'Questões e exercícios',
                'Avaliações',
                'Taxonomias',
                'Arquivos e atividades complementares',
                'Fórum',
                'Turmas',
                'Tarefas',
                'Relatórios'
              ]}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route //metabase
          path={PATHS.METRICS.TAB_ROOT}
          element={
            <PrivateRoute
              as={Reports}
              roleName={['Visualizar dados e métricas', 'Mantenedor', 'Institucional', 'Regional']}
              roleGroup={[
                'Questionário de Percepção',
                'Cursos',
                'Projetos',
                'Participantes e perfis administrativos',
                'Questões e exercícios',
                'Avaliações',
                'Taxonomias',
                'Arquivos e atividades complementares',
                'Fórum',
                'Cursos',
                'Tarefas',
                'Relatórios',
                'Turmas'
              ]}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route
          path={PATHS.METRICS.LIST_V1}
          element={
            <PrivateRoute
              as={Metrics1}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route
          path={PATHS.METRICS.PROFILE_ROOT}
          element={
            <PrivateRoute
              as={MetricsProfile}
              enabled={abilities?.metricas}
            />
          }
        />
        <Route
          path={PATHS.QUIZ.LIST}
          element={
            <PrivateRoute
              as={Quiz}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path={PATHS.QUIZ.DATA_ROOT}
          element={
            <PrivateRoute
              as={QuizData}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path={PATHS.QUIZ.STUDENT_ROOT}
          element={
            <PrivateRoute
              as={QuizDataOpenAnswers}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path={PATHS.QUIZ.CREATE_ROOT}
          element={
            <PrivateRoute
              as={QuizCreate}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path={PATHS.QUIZ.BY_REP_ROOT}
          element={
            <PrivateRoute
              as={QuizData}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        <Route
          path={PATHS.QUIZ.OPEN_ANSWERS_ROOT}
          element={
            <PrivateRoute
              as={QuizDataProposal}
              roleName="Visualizar questionário de percepção"
              roleGroup="Questionário de Percepção"
              enabled={abilities?.nps}
            />
          }
        />
        {/* desafio ao vivo */}
        <Route
          path={PATHS.LIVE_CHALLENGE.ADMIN_LIST}
          element={
            <PrivateRoute
              as={LiveChallengeList}
              enabled={abilities?.['desafio-ao-vivo']}
            />
          }
        />
        <Route
          path={PATHS.LIVE_CHALLENGE.ADMIN_PANEL_ROOT}
          element={
            <LiveChallengeProvider>
              <PrivateRoute
                as={LiveChallengeControlPanel}
                enabled={abilities?.['desafio-ao-vivo']}
              />
            </LiveChallengeProvider>
          }
        />
        {/* seletivos admin */}
        <Route
          path={PATHS.ADMIN_SELETIVO.LIST}
          element={<PrivateRoute as={SelectionProcessesList} />}
        />
        <Route
          path={PATHS.ADMIN_SELETIVO.DETAIL_ROOT}
          element={<SelectionProcessDetail />}
        />
        {/* atividades complementares */}
        <Route
          path={PATHS.COMPLEMENTARY_ACTIVITY.LIST}
          element={
            <PrivateRoute
              as={ComplementaryActivity}
              roleName="Visualizar lista de atividades"
              roleGroup="Arquivos e atividades complementares"
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path={PATHS.COMPLEMENTARY_ACTIVITY.BY_COURSE_ROOT}
          element={
            <PrivateRoute
              as={ViewActivity}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path={PATHS.COMPLEMENTARY_ACTIVITY.DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ComplementaryActivityDetails}
              roleName="Visualizar lista de atividades"
              roleGroup="Arquivos e atividades complementares"
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          roleName="Visualizar lista de atividades"
          roleGroup="Arquivos e atividades complementares"
          path={PATHS.COMPLEMENTARY_ACTIVITY.EVALUATION_ROOT}
          element={
            <PrivateRoute
              as={ComplementaryActivityEvaluationView}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          roleName="Visualizar lista de atividades"
          roleGroup="Arquivos e atividades complementares"
          path={PATHS.COMPLEMENTARY_ACTIVITY.EVALUATION_ARCHIVE_ROOT}
          element={
            <PrivateRoute
              as={ActivityEvaluationArchive}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          roleName="Visualizar lista de atividades"
          roleGroup="Arquivos e atividades complementares"
          path={PATHS.COMPLEMENTARY_ACTIVITY.EVALUATE_ROOT}
          element={
            <PrivateRoute
              as={ActivityEvaluation}
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path={PATHS.COMPLEMENTARY_ACTIVITY.DATA_ROOT}
          element={
            <PrivateRoute
              as={ActivityData}
              roleName="Visualizar lista de atividades"
              roleGroup="Arquivos e atividades complementares"
              enabled={abilities?.['cursos-ativ-complementar']}
            />
          }
        />
        <Route
          path={PATHS.ADMIN.ROOT}
          element={<PrivateRoute as={DashboardAdmin} />}
        />
        <Route
          path={PATHS.CLASSROOM.LIST}
          element={
            <PrivateRoute
              as={Classroom}
              roleName="Visualizar lista de turmas"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.TURMA}
          element={
            <PrivateRoute
              as={Classroom}
              roleName="Visualizar lista de cursos"
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.CLASSROOM.BY_COURSE_INSTITUTION_ROOT}
          element={<PrivateRoute as={Classroom} />}
        />
        <Route
          path={PATHS.COURSE.COURSE_CREATE_PARTICIPANT}
          element={
            <PrivateRoute
              as={CreateOrUpdateParticipant}
              roleName={['Visualizar lista de cursos', 'Visualizar lista de turmas']}
              roleGroup="Cursos"
            />
          }
        />
        <Route
          path={PATHS.COURSE.COURSE_EDIT_PARTICIPANT_ROOT}
          element={<PrivateRoute as={CreateOrUpdateParticipant} />}
        />
        <Route
          path={PATHS.CLASSROOM.MANAGE_PARTICIPANTS_ROOT}
          element={<PrivateRoute as={ManageParticipants} />}
        />
        <Route
          path={PATHS.MISC.JOURNEY}
          element={
            <PrivateRoute
              as={Journey}
              // enabled={abilities?.jornada}
            />
          }
        />
        <Route
          path={PATHS.FEED.POST_ROOT}
          element={
            <PrivateRoute
              as={FeedPost}
              roleName="Visualizar postagens e comentários"
              roleGroup="Fórum"
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_LIST}
          element={
            <PrivateRoute
              as={ExamsResolution}
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path={PATHS.PROFILE.ROOT}
          element={<PrivateRoute as={Profile} />}
        />
        <Route
          path={PATHS.PARTICIPANTS.NOTIFICATIONS_EXTRACT}
          element={
            <PrivateRoute
              as={NotificationExtract}
              roleName="Enviar notificações de engajamento"
              roleGroup="Participantes e perfis administrativos"
            />
          }
        />
        <Route
          path={PATHS.PARTICIPANTS.NOTIFICATIONS}
          element={
            <PrivateRoute
              as={Notifications}
              roleName="Enviar notificações de engajamento"
              roleGroup="Participantes e perfis administrativos"
            />
          }
        />
        <Route
          path={PATHS.PARTICIPANTS.ADMIN_PROFILE_ROOT}
          element={<PrivateRoute as={ManageProfile} />}
        />
        <Route
          roleName="Visualizar lista e gerenciar perfis"
          roleGroup="Participantes e perfis administrativos"
          path={PATHS.PARTICIPANTS.ADMIN_PROFILES}
          element={<PrivateRoute as={AdministrativeProfiles} />}
        />
        <Route
          path={PATHS.PARTICIPANTS.LIST}
          element={
            <PrivateRoute
              as={Participants}
              roleName={['Visualizar lista de participantes', 'Visualizar lista e gerenciar perfis', 'Enviar notificações de engajamento']}
              roleGroup="Participantes e perfis administrativos"
            />
          }
        />
        <Route
          path={PATHS.PROFILE.USER_ROOT}
          element={
            <PrivateRoute
              as={UsersShow}
              enabled={abilities?.jornada}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.GROUP_PROJECT_ABOUT_ROOT}
          element={
            <PrivateRoute
              as={ProjectsAbout}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.ABOUT_ROOT}
          element={
            <PrivateRoute
              as={ProjectsAbout}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.GROUP_DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ViewGroupProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.GROUPS}
          element={
            <PrivateRoute
              as={GroupProjects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.INDIVIDUAL_DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ViewIndividualProject}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.INDIVIDUALS}
          element={
            <PrivateRoute
              as={IndividualProjects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.PERSONALIZED}
          element={
            <PrivateRoute
              as={PersonalizedProjects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        <Route
          path={PATHS.PROJECTS.LIST}
          element={
            <PrivateRoute
              as={Projects}
              roleName={'Visualizar lista de projetos'}
              roleGroup={'Projetos'}
              enabled={abilities?.projetos}
            />
          }
        />
        {/** Redação * */}
        <Route
          path={PATHS.ESSAY.CONSULT_ROOT}
          element={
            <PrivateRoute
              as={EssayConsult}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.ABOUT_ROOT}
          element={
            <PrivateRoute
              as={EssayAbout}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.CORRECTION_ROOT}
          element={
            <PrivateRoute
              as={EssayCorrection}
              roleName={'Realizar correção'}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.VIEW_ROOT}
          element={
            <PrivateRoute
              as={EssayCorrection}
              roleName={'Visualizar redação'}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.MONITORING_ROOT}
          element={
            <PrivateRoute
              as={EssayMonitoring}
              roleName={['Realizar correção', 'Visualizar redação']}
              roleGroup={'Redação'}
              enabled={abilities?.redacao}
            />
          }
        />
        <Route
          path={PATHS.ESSAY.LIST}
          element={
            <PrivateRoute
              as={Essay}
              enabled={abilities?.redacao}
            />
          }
        />
        {/** Ementa * */}
        <Route
          path={PATHS.MISC.SYLLABUS_SUBJECTS}
          element={
            <PrivateRoute
              as={Taxonomies}
              roleName="Visualizar lista de ementas, tópicos e subtópicos"
              roleGroup="Ementas"
            />
          }
        />
        {/** Banners * */}
        <Route
          path={PATHS.BANNERS.LIST}
          element={
            <PrivateRoute
              as={BulletinBoards}
              roleName="Visualizar Mural"
              roleGroup="Mural"
            />
          }
        />
        {/** Gerenciamento de provas * */}
        <Route
          path={PATHS.EXAM.EXAMS_QUESTION_COMMENT_ROOT}
          element={<PrivateRoute as={CommentQuestion} />}
        />
        <Route
          path={PATHS.EXAM.OFFLINE_ROOT}
          element={
            <PrivateRoute
              as={OfflineExam}
              roleName={['Visualizar exercícios', 'Visualizar lista de provas', 'Visualizar lista de simulados', 'Visualizar banco de questões', 'Visualizar exercícios', 'Visualizar resultados']}
              roleGroup={['Questões e exercícios', 'Avaliações']}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.BY_TAB_ROOT}
          element={
            <PrivateRoute
              as={Exams}
              roleName={['Visualizar exercícios', 'Visualizar lista de provas', 'Visualizar lista de simulados', 'Visualizar banco de questões', 'Visualizar exercícios', 'Visualizar resultados']}
              roleGroup={['Questões e exercícios', 'Avaliações']}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.RESULT_LIST}
          element={
            <PrivateRoute
              as={Exams}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
            />
          }
        />
        <Route
          path={PATHS.EXAM.RESULT_DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ExamMetricsList}
              roleName="Visualizar exercícios"
              roleGroup="Questões e exercícios"
            />
          }
        />
        <Route
          path={PATHS.EXAM.MOCK_ABOUT_ROOT}
          element={
            <PrivateRoute
              as={MockExamsAbout}
              enabled={abilities?.['avaliacoes-simulados']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.ABOUT_ROOT}
          element={
            <PrivateRoute
              as={ExamsAbout}
              enabled={abilities?.['avaliacoes-provas']}
            />
          }
        />
        <Route
          path={PATHS.EXAM.LIST}
          element={
            <PrivateRoute
              as={ExamsResolution}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.MY_RESULTS}
          element={
            <PrivateRoute
              as={ExamsResolution}
              enabled={abilities?.avaliacoes}
            />
          }
        />
        <Route
          path={PATHS.EXAM.EXAMS_RESULTS}
          element={
            <PrivateRoute
              as={ExamMetrics}
              roleName={'Visualizar resultados'}
              roleGroup={'Avaliações'}
            />
          }
        />
        <Route
          path={PATHS.MISC.SYLLABUS_QUESTION_BANK}
          element={
            <PrivateRoute
              as={QuestionsDatabase}
              roleName="Visualizar banco de questões"
              roleGroup="Questões e exercícios"
            />
          }
        />
        <Route
          path={PATHS.MISC.SYLLABUS_PUBLIC_QUESTIONS}
          element={<PrivateRoute as={UpdatePublicQuestions} />}
        />
        <Route
          path={PATHS.MISC.SYLLABUS_QUESTION_BOOK_ROOT}
          element={<PrivateRoute as={UpdateQuestionBook} />}
        />
        <Route
          path={PATHS.STUDY_PLAN.BLOCK_ROOT}
          element={
            <PrivateRoute
              as={StudyBlock}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.STUDY_PLAN.DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ViewStudyPlan}
              enabled={abilities?.['plano-de-estudo']}
            />
          }
        />
        <Route
          path={PATHS.LEGAL.HELP_VIDEO_ROOT}
          element={<PrivateRoute as={HelpViewVideo} />}
        />
        <Route
          path={PATHS.MISC.COMPONENTS}
          element={<PrivateRoute as={Example} />}
        />
        <Route
          path={PATHS.MISC.DESIGN_SYSTEM}
          element={<PrivateRoute as={DesignSystem} />}
        />
        <Route
          path={PATHS.AUDITORIUM.DETAIL_ROOT}
          element={
            <PrivateRoute
              as={AuditoriumView}
              enabled={abilities?.auditorio}
            />
          }
        />
        <Route
          path={PATHS.AUDITORIUM.LIST}
          element={<PrivateRoute as={Auditorium} />}
        />
        <Route
          path={PATHS.LIVE_CLASSES.DETAIL_ROOT}
          element={
            <PrivateRoute
              as={ViewLiveClass}
              enabled={abilities?.['aulas-ao-vivo']}
              roleGroup="Aulas ao vivo"
              roleName="Visualizar aulas ao vivo"
            />
          }
        />
        <Route
          path={PATHS.LIVE_CLASSES.LIST}
          element={
            <PrivateRoute
              as={LiveClasses}
              roleGroup="Aulas ao vivo"
              roleName="Visualizar aulas ao vivo"
              enabled={abilities?.['aulas-ao-vivo']}
            />
          }
        />
        <Route
          path={PATHS.WEEK_CHALLENGE.PARTICIPANT_RESULT_ROOT}
          element={
            <PrivateRoute
              as={ViewParticipantResult}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path={PATHS.WEEK_CHALLENGE.CHALLENGE_ROOT}
          element={
            <PrivateRoute
              as={ViewChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path={PATHS.WEEK_CHALLENGE.BY_TAB_ROOT}
          element={
            <PrivateRoute
              as={WeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path={PATHS.WEEK_CHALLENGE.LIST}
          element={
            <PrivateRoute
              as={WeekChallenge}
              enabled={abilities?.['desafio-da-semana']}
            />
          }
        />
        <Route
          path={PATHS.DUELS.LIST}
          element={<PrivateRoute as={Duels} />}
        />
        <Route
          path={PATHS.DUELS.DETAIL_ROOT}
          element={<PrivateRoute as={DuelsPlayer} />}
        />
        <Route
          path={PATHS.LESSON_PLAN.ROOT}
          element={
            <PrivateRoute
              as={LessonPlan}
              enabled={abilities?.['plano-de-aula']}
            />
          }
        />
        <Route
          path={PATHS.MISC.SCHEDULE}
          element={<PrivateRoute as={CourseSchedule} />}
        />
      </Route>
      {/** Fim das Rotas de Main Layout */}

      <Route
        path={PATHS.MISC.HEALTHCHECK}
        element={<Healthcheck />}
      />

      <Route
        path={PATHS.MISC.NOT_FOUND}
        element={<NotFound />}
      />
    </RRDRoutes>
  );
};
